import { GBase } from 'interfaces/IGlobalCatalogue';

import { RootState } from '../Store';

export const selectActiveGOrgId = (state: RootState): string | null =>
  state.globalCatalogueReducer.activeGOrganisation || null;

const NO_SEGMENTS: GBase[] = [];

/** The segment options, with a stable empty list until they load. */
export const getSegmentOptions = (state: RootState): GBase[] =>
  state.globalCatalogueReducer.collectionOptions?.segments ?? NO_SEGMENTS;
